import React, { useCallback, useEffect, useState } from "react";
import { FormField } from "../../../../ui-kit/FormField/FormField";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Table } from "./Table/Table";
import { IButton } from "../../../../ui-kit/IButton/IButton";
import styles from "./CustomDictionary.module.scss";
import "./CustomDictionary.module.scss";
import moment from "moment";
import { schema } from "./validator";
import store from "../../../../store/customDictionariesStore";
import { useParams } from "react-router-dom";
import { notification } from "antd";
import { runInAction } from "mobx";
import HistoryModal from "../../components/CustomDictionary/HistoryModal";
import { observer } from "mobx-react-lite";

const initialFocus = {
  dictionaryValue: false,
};

export const CustomDictionary: React.FC = observer(() => {
  const { dictionaryName } = useParams();

  const loadInititalData = async () => {
    const result = await store.getCustomDictionaryItems(dictionaryName);
    setInitialItems(result.data);
  };

  const [isFocused, setIsFocused] = useState(initialFocus);

  const [currentItem, setCurrentItem] = useState(null);
  const [isVisibleForm, setIsVisibleForm] = useState(false);

  const [initialItems, setInitialItems] = useState([]);

  const defaultValues = {
    dictionaryValue: currentItem?.dictionaryValue as string,
  };

  type NotificationType = "success" | "info" | "warning" | "error";

  const openNotificationWithIcon = (
    type: NotificationType,
    message,
    description,
  ) => {
    notification[type]({
      message,
      description,
    });
  };

  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const isAddMode = !currentItem;

  const watchAllField = watch();

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setIsFocused({ ...isFocused, [name]: true });
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;

    if (watchAllField[name] !== "") {
      setIsFocused({ ...isFocused, [name]: true });
    } else {
      setIsFocused({ ...isFocused, [name]: false });
    }
  };

  const handleHistory = () => {
    runInAction(() => {
      store.dictionaryName = dictionaryName;
      store.isHistoryModalVisible = true;
    });
  };

  const handleResetForm = () => {
    reset(defaultValues);
    setCurrentItem(null);
    setIsFocused(initialFocus);
  };

  const handleItem = (data) => {
    setCurrentItem(data);
    setIsVisibleForm(true);
    reset(currentItem);
  };

  const handlePrepareForm = useCallback(() => {
    setIsVisibleForm(true);
    handleResetForm();
  }, [isVisibleForm]);

  const onSubmit = async (data) => {
    if (isAddMode) {
      data.id = 0;
      const dictionary = await store.getCustomDictionaryByName(dictionaryName);
      data.customDictionaryId = dictionary.data.id;
      try {
        await store.createCustomDictionaryItemsmodel([data]);
      } catch (err) {
        openNotificationWithIcon("error", "Error", err.message);
      }
    } else {
      try {
        await store.updateCustomDictionaryItems([data]);
      } catch (err) {
        openNotificationWithIcon("error", "Error", err.message);
      }
    }
    loadInititalData();
    handleResetForm();
    setIsVisibleForm(false);
  };

  useEffect(() => {
    if (!isAddMode) {
      reset({
        dictionaryValue: currentItem?.dictionaryValue,
        ...currentItem,
      });
    }
  }, [currentItem]);

  useEffect(() => {
    loadInititalData();
  }, []);

  return (
    <div className={styles.items}>
      {store.isHistoryModalVisible ? <HistoryModal /> : null}
      {!isVisibleForm || initialItems.length ? (
        <div className={styles.buttons}>
          <IButton onClick={handlePrepareForm} className={styles.addButton}>
            Создать запись
          </IButton>
          <IButton onClick={handleHistory} className={styles.addButton}>
            История изменений
          </IButton>
          <IButton onClick={handlePrepareForm} className={styles.addButton}>
            Удалить справочник
          </IButton>
        </div>
      ) : (
        ""
      )}

      <div className={styles.list}>
        <Table rows={initialItems} handleItem={handleItem} item={currentItem} />
      </div>
      <div className={styles.wrapper}>
        {isVisibleForm && (
          <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.item}>
              <FormField
                label="Значение справочника"
                name="dictionaryValue"
                register={register}
                type="text"
                isFocused={isFocused.dictionaryValue}
                currentValue={watchAllField.dictionaryValue}
                error={errors?.dictionaryValue?.message}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
            </div>

            <div className={styles.item}>
              <IButton type="submit" className={styles.button}>
                Cохранить
              </IButton>
            </div>
          </form>
        )}
      </div>
    </div>
  );
});
